import React from 'react';
import {withRouter} from 'react-router-dom';
import Yup from 'yup';
import {Button, Form} from 'semantic-ui-react';
import {Alert} from 'componentLibrary';
import {TextBoxField} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import {connectWithCore} from 'framework/hocs';
import {withFormik} from 'formik';
import REST from 'go/requests/rest';
import {checkIfEmailIsValid} from 'common/utils';
import _ from 'lodash';

export const CreateTaskForm = ({
  values,
  errors,
  touched,
  handleChange,
  handleBlur,
  handleSubmit,
  setFieldValue,
  isSubmitting,
  status,
  setStatus,
  title,
  text,
  actionLabel,
  confirmationMessage,
  errorMessage,
  loading,
  showAddReviewerModal,
  cancelModal,
  confirmModal,
}) => {
  const handleEmailChange = (e) => {
    setStatus({error: null, validUser: false});
    handleChange(e);
  };

  return (
    <Form onSubmit={handleSubmit} id="org-team-form">
      <p>{text}</p>
      <div>
        <TextBoxField
          size="medium"
          label={<strong>Enter individual reviewer email</strong>}
          title="Enter email"
          name="email"
          id="email"
          handleChange={handleEmailChange}
          handleBlur={handleBlur}
          value={values.email}
          errorMessages={errors.email}
          displayError={touched.email && errors.email}
        />
        <Button
          primary
          title="Enter email"
          id="enterBtn"
          type="submit"
          disabled={errors.email || !values.email}
        >
          Enter
        </Button>
        <div className="user-search-result">
          {status && status.validUser && !errors.email ? (
            <React.Fragment>
              <p>{confirmationMessage}</p>
              <h5>{values.email}</h5>
              <Button
                disabled={errors.email || !values.email || !(status && status.validUser)}
                primary
                title="Add Individual Reviewer"
                id="addBtn"
                onClick={(e) => {
                  setFieldValue('addAction', true);
                  handleSubmit(e);
                }}
              >
                {actionLabel}
              </Button>
            </React.Fragment>
          ) : (
            status &&
            status.error && (
              <React.Fragment>
                <Alert
                  size="small"
                  content={status.error}
                  paragraph={false}
                  type="error"
                  confirmButton="hidden"
                >
                  <h5>{values.email}</h5>
                </Alert>
              </React.Fragment>
            )
          )}
        </div>
      </div>
    </Form>
  );
};

export const DynamicCreateAssignedTask = withFormik({
  mapPropsToValues: () => ({email: null, addAction: false}),
  mapPropsToStatus: () => ({error: null, validUser: false}),

  validationSchema: (props) =>
    Yup.object().shape({
      email: Yup.mixed()
        .required('Please enter a valid email address')
        .test('is-valid-email', 'Please enter a valid email address', (value) => {
          return checkIfEmailIsValid(value);
        }),
    }),

  addItem: (values, props) => {
    REST.user
      .getRegisteredUser(props.token, values.email)
      .then(REST.handler.handleResponse)
      .then((res) => {
        console.log('success');
      })
      .catch((err) => {
        console.error('err');
      });
  },

  handleSubmit: (values, {props, setSubmitting, setFieldValue, setStatus}) => {
    if (!values.addAction) {
      const userRole = _.get(props, 'userRole');
      const programEntityType = _.get(props, 'programEntityType');
      const programId = _.get(props, 'programId');
      REST.user
        .getRegisteredUserRole(values.email, programEntityType, programId, userRole)
        .then(REST.handler.handleResponse)
        .then((roles) => {
          if (roles.length > 0) {
            setStatus({error: null, validUser: true});
            console.log('success');
          } else {
            setStatus({error: props.errorMessageSecondary, validUser: false});
            console.error(props.errorMessageSecondary);
          }
        })
        .catch((err) => {
          console.error('err');
          setStatus({error: props.errorMessage, validUser: false});
        });
    } else {
      const data = {
        workflowMessageName: `assignIndividualReviewTask-${props.grantId}`,
        variables: {individualUserId: values.email},
      };
      setFieldValue('addAction', false);
      REST.workflow
        .sendMessage('assignIndividualReviewMsg', data)
        .then(REST.handler.handleResponse)
        .then((res) => {
          props.confirmModal(_.get(props, 'successMessage'));
        })
        .catch((err) => {
          console.error('err');
        });
    }
  },

  displayName: 'BasicForm',
})(CreateTaskForm);

export default withRouter(connectWithCore(DynamicCreateAssignedTask));
